import React from 'react';
import {CheckCircleFill, CloseCircleFill} from 'antd-mobile-icons';
import {scanDataInfo} from "../pages/delivery/task/NewAssignmentsScanPage";
import {t} from "../i18n";

export type PickupInfoPanelProps = {
    id: string;
    status: 'success' | 'failure';
    item: scanDataInfo;
}

export const PickupInfoPanel: React.FC<PickupInfoPanelProps> = ({id, status, item}) => {
    const success = status === 'success';


    return (
        <div className="flex flex-col gap-1.5 p-3 bg-white text-gray-600">
            <div className="flex items-center gap-2 w-full justify-between mb-2">
                <div className="font-semibold text-2xl">{id}</div>
                {success ? <CheckCircleFill className="text-green-600"/> :
                    <CloseCircleFill className="text-red-600"/>}
            </div>

            {success ? (
                <div className="flex gap-4 my-4">
                    <div
                        className="flex-1 flex flex-col items-center justify-center bg-blue-50 rounded-xl py-3 aspect-square">
                        <span className="text-2xl font-bold text-blue-600">{item.stopNumber}</span>
                        <span className="text-1xl font-bold text-blue-500">{t('pages.dsp.home.receivingSorting.stop')}</span>
                    </div>
                    <div
                        className="flex-1 flex flex-col items-center justify-center bg-green-50 rounded-xl py-3 aspect-square">
                        <span className="text-2xl font-bold text-green-600">{item.routeName}</span>
                        <span className="text-1xl font-bold text-green-500">{t('pages.dsp.home.receivingSorting.route')}</span>
                    </div>
                </div>
            ) : null}

        </div>
    );
};